module.exports = __webpack_public_path__ + "img/17_8.8c11abe3.png";